import { ChartDrawOption } from '@/modules/ta/widget/models/drawoptions/ChartDrawOption';
import { PlotType } from '@/modules/ta/widget/widget.constants';
import { GradientTypes } from '@/modules/ta/widget/builder.constants';
import { Position } from '@/modules/core/charts/am5/charts.constants';

export class PieChartDrawOption extends ChartDrawOption {
  /**
   * @var {boolean}
   */
  show_labels;

  /**
   * @var {boolean}
   */
  show_label_names;

  /**
   * @var {boolean}
   */
  show_label_values;

  /**
   * @var {boolean}
   */
  show_label_percent;

  /**
   * @var {boolean}
   */
  is_normalized;

  /**
   * @var {boolean}
   */
  start_angle;

  /**
   * @var {number}
   */
  other_percent;

  /**
   * @var {boolean}
   */
  label_percent;

  /**
   * @var {boolean}
   */
  inner_radius;

  /**
   * @var {number}
   */
  rounded_corners;

  /**
   * @var {boolean}
   */
  show_column_shadows;

  /**
   * @var {number}
   */
  pie_semicircle_angle;

  /**
   * @var {string}
   */
  background_gradient;

  /**
   * @var {string}
   */
  gradient_color;

  /**
   * @var {boolean}
   */
  show_grainy_pattern;

  /**
   * @var {number}
   */
  grainy_pattern_size;

  /**
   * @var {number}
   */
  pie_grain_density;

  /**
   * @var {boolean}
   */
  pie_donut_sum;

  /**
   * @var {boolean}
   */
  pie_border_stroke;

  /**
   * @var {number}
   */
  pie_rotation_angle;

  /**
   * @var {string}
   */
  pie_gradient_options;

  /**
   * @var {string}
   */
  pie_color_picker;

  /**
   * @var {number}
   */
  v2_inner_radius;

  /**
   * @var {boolean}
   */
  pie_variable_radius;

  /**
   * @var {boolean}
   */
  classic_drill_down_behaviour;

  /**
   * @var {string}
   */
  align_labels;

  /**
   * @var {string}
   */
  pie_legend_position;

  constructor(model = {}) {
    super(model);

    this.setValidPlotType(model);

    this.show_labels = model.show_labels !== undefined ? model.show_labels : true;
    this.show_label_percent =
      model.show_label_percent !== undefined ? model.show_label_percent : true;
    this.show_label_names = model.show_label_names !== undefined ? model.show_label_names : true;
    this.show_label_values = model.show_label_values || false;
    this.start_angle = model.start_angle || 90;
    this.is_normalized = model.is_normalized || false;
    this.other_percent = model.other_percent || 0;
    this.label_percent = model.label_percent || 0;
    this.inner_radius = model.inner_radius || 0;
    this.hide_grid_lines = model.hide_grid_lines || false;
    this.has_tooltip = model.has_tooltip ?? true;
    this.depth = model.depth ?? 0;
    this.angle = model.angle ?? 0;
    this.is_hand_drawn = model.is_hand_drawn ?? false;
    this.rounded_corners = model.rounded_corners ?? 0;
    this.show_column_shadows = model.show_column_shadows ?? true;
    this.pie_semicircle_angle = model.pie_semicircle_angle;
    this.background_gradient = model.background_gradient ?? GradientTypes.SOLID;
    this.gradient_color = model.gradient_color;
    this.show_grainy_pattern = model.show_grainy_pattern ?? false;
    this.grainy_pattern_size = model.grainy_pattern_size ?? 1;
    this.pie_grain_density = model.pie_grain_density ?? 0;
    this.pie_donut_sum = model.pie_donut_sum ?? false;
    this.pie_border_stroke = model.pie_border_stroke ?? false;
    this.pie_rotation_angle = model.pie_rotation_angle ?? 90;
    this.pie_gradient_options = model.pie_gradient_options ?? GradientTypes.SOLID;
    this.pie_color_picker = model.pie_color_picker;
    this.v2_inner_radius = model.v2_inner_radius ?? 40;
    this.pie_variable_radius = model.pie_variable_radius ?? false;
    this.classic_drill_down_behaviour = model.classic_drill_down_behaviour ?? false;
    this.align_labels = model.align_labels ?? false;
    this.wrap_metric_name = model.wrap_metric_name ?? false;
    this.pie_legend_position = model.pie_legend_position ?? Position.BOTTOM;
  }

  setValidPlotType(model) {
    const validTypes = [PlotType.PIE, PlotType.DONUT];

    if (!model.plot_type || !validTypes.includes(model.plot_type)) {
      this.plot_type = PlotType.PIE;
    } else {
      this.plot_type = model.plot_type;
    }
  }
}
